import DataProviderType from "../../consts/DataProviderType";
import DataSourceDataTableReadDto from "./DataSourceDataTableReadDto";
import DataTableReadDto from "./DataTableReadDto";
import PathDataTableReadDto from "./PathDataTableReadDto";

class DataProviderReadDto {

    Type: string = "";
    Id: number | null = 0;
    Label: string = "";
    WithDatabase: boolean = true;
    WithTable: boolean = true;

    DataSourceDataTableRead: DataSourceDataTableReadDto | null = null;

	constructor(dataTable: DataTableReadDto | null) {

        if (dataTable instanceof DataSourceDataTableReadDto) {
            this.Type = DataProviderType.DataSource;
            this.Id = dataTable.DataSourceId;
            this.Label = dataTable.DataSourceLabel;
            this.WithDatabase = true;
            this.WithTable = true;

            this.DataSourceDataTableRead = dataTable
        }

        if (dataTable instanceof PathDataTableReadDto) {
            this.Type = DataProviderType.PathDataTable;
            this.Id = dataTable.PathId;
            this.Label = dataTable.PathName;
            this.WithDatabase = false;
            this.WithTable = false;
        }
	}
}

export default DataProviderReadDto;